import { render, staticRenderFns } from "./wrapper-tree.vue?vue&type=template&id=79c6f150&scoped=true&"
import script from "./wrapper-tree.vue?vue&type=script&lang=js&"
export * from "./wrapper-tree.vue?vue&type=script&lang=js&"
import style0 from "./wrapper-tree.vue?vue&type=style&index=0&id=79c6f150&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c6f150",
  null
  
)

export default component.exports